export default {
    'simple-text': {
        name: window.i18n.__('Alphanumérique'),
    },
    'rich-text': {
        name: window.i18n.__('Alphanumérique'),
    },
    numeric: {
        name: window.i18n.__('Numérique'),
    },
    amount: {
        name: window.i18n.__('Montant avec devise'),
    },
    unit: {
        name: window.i18n.__('Champ numérique avec unité'),
    },
    'numeric-with-unit': {
        name: window.i18n.__('Champ numérique avec unité'),
    },
    radio: {
        name: window.i18n.__('Bouton radios'),
    },
    select: {
        name: window.i18n.__('Liste de choix'),
    },
    checkbox: {
        name: window.i18n.__('Choix multiple'),
    },
    date: {
        name: window.i18n.__('Date au format jj/mm/AAAA ou AAAA-mm-jj'),
    },
    time: {
        name: window.i18n.__('Heure au format hh:mm'),
    },
    email: {
        name: window.i18n.__('Adresse email'),
    },
    url: {
        name: window.i18n.__('Alphanumérique'),
    },
    boolean: {
        name: window.i18n.__('"Y" pour oui ou "N" pour non'),
    },
    third: {
        name: window.i18n.__('Client/Prospect/Fournisseur'),
    },
    item: {
        name: window.i18n.__('Produit/Service'),
    },
    people: {
        name: window.i18n.__('Contact'),
    },
    staff: {
        name: window.i18n.__('Collaborateur'),
    },
};
